import { Trip, Map } from './../classes.js';
import { random_string, can_display } from './../function/common.js';
import { get_marker_color } from './../vars/icons.js';

export function event__element(data, edit = false){
	let $wrapper = '';
	let $content = '';
	let $card_content = '';
	let $markers = '';
	let $card_buttons = '';
	let $hidden = '';
	let fields = data.fields;
	let first_marker = 0;
	let first_m_id = 0;
	let temp_id = '';
	let style = {};
	let background_color = 'primary';
	
	let $event_branding = '';
	let $event_links = '';
	let $event_header = '';
	let $event_body = '';
	
	//if there are no markers for the event, add an empty one that can be updated
	if(Object.keys(data.m).length == 0){
		temp_id = random_string(9);
		
		//set a trip object so we get proper references later
		Trip.content.b[data.block_id].e[data.id].m = {}
		Trip.content.b[data.block_id].e[data.id].m[temp_id] = {}
		
		//set immediate data
		data.m = {};
		data.m[temp_id] = {};
		data.m[temp_id].id = Trip.content.b[data.block_id].e[data.id].m[temp_id].id = temp_id;
		data.m[temp_id].type = Trip.content.b[data.block_id].e[data.id].m[temp_id].type = data.c.style;
	}
	
	//get the first marker data
	for (const [m_id, m] of Object.entries(data.m)) {
		first_m_id = m_id;
		first_marker = m.marker;
		break;
	}
	
	//set style of event
	//load the style details from our Array
	if(isNaN(data.c.style)){
		data.c.style = 1;
		style = Trip.styles[1];
		Trip.content.b[data.block_id].e[data.id].c.style = 1;
	}else{
		style = Trip.styles[data.c.style];
		background_color = get_marker_color(Trip.styles[data.c.style].category);
	}
	
	if(edit){
		
		$content = $('<div/>', {
			'class': `e editable editable--event card card--event event`
		});
		
		$content.append(`
			<div class="card__image">
				<span class="material material-symbols-outlined">
					${style.icon}
				</span>
				<input type="hidden" name="b[${data.block_id}][e][${data.id}][c][style]" value="${data.c.style}" />
			</div>
		`);
		
		//create card content
		$card_content = $('<div/>', {
			'class': `card__content`,
		});
		
		//set the name of the event
		$card_content.append(
			$('<div/>', {
				'class': `gc--2 bold form__row`,
			}).append(
				$('<div/>', {}).append(
					$('<label/>', {
						'for': `event__name--${data.id}`
						, 'text': "Event Name"
					}),
					$('<input/>', {
						'id': `event__name--${data.id}`
						, 'type': "text"
						, 'name': `b[${data.block_id}][e][${data.id}][c][name]`
						, 'value': data.c.name
					})
				)
			)
		);
		
		//create the fields based on the fields list
		if(fields.map){
			$markers= $('<div/>', {
				'class': `gr--2 g--center`,
			});
			
			//else, display the existing
			for (const [m_id, m] of Object.entries(data.m)) {
				$markers.append(`
					<button class="btn btn--small btn--marker btn--marker--place" data-m_id="${m_id}" data-marker="${m.marker}">
						Place Marker
					</button>
					<input type="hidden" name="b[${data.block_id}][e][${data.id}][m][${m_id}][id]" class="m_id" value="${m_id}" />
					<input type="hidden" name="b[${data.block_id}][e][${data.id}][m][${m_id}][lat]" class="lat" value="${m.lat}" />
					<input type="hidden" name="b[${data.block_id}][e][${data.id}][m][${m_id}][lng]" class="lng" value="${m.lng}" />
					<input type="hidden" name="b[${data.block_id}][e][${data.id}][m][${m_id}][zoom]" class="zoom" value="${m.zoom}" />
					<input type="hidden" name="b[${data.block_id}][e][${data.id}][m][${m_id}][type]" class="type" value="${m.type}" />
				`);
			}
			
			$card_content.append($markers);
		}
		
		if(fields.date_time){
			
			//${data.c.time_hour}
			//${data.c.time_minute}
			
			$card_content.append(`
				<div class="gc--2 bold form__row form__row--two_col">
					<div>
						<label for="event__date--${data.id}">Date</label>
						<input id="event__date--${data.id}" class="datepicker" type="text" name="b[${data.block_id}][e][${data.id}][c][date]" value="${data.c.date}" />
					</div>
					<div class="event__time_select">
						<span class="fake_label">Time</span>
						<div class="event__time_select--entry">
							<select id="event__time_hour--${data.id}" name="b[${data.block_id}][e][${data.id}][c][time_hour]" aria-label="Event Hour">
								<option value="" ${data.c.time_hour == '' ? 'selected' : ''}></option>
								<option value="1" ${data.c.time_hour == '1' ? 'selected' : ''}>1</option>
								<option value="2" ${data.c.time_hour == '2' ? 'selected' : ''}>2</option>
								<option value="3" ${data.c.time_hour == '3' ? 'selected' : ''}>3</option>
								<option value="4" ${data.c.time_hour == '4' ? 'selected' : ''}>4</option>
								<option value="5" ${data.c.time_hour == '5' ? 'selected' : ''}>5</option>
								<option value="6" ${data.c.time_hour == '6' ? 'selected' : ''}>6</option>
								<option value="7" ${data.c.time_hour == '7' ? 'selected' : ''}>7</option>
								<option value="8" ${data.c.time_hour == '8' ? 'selected' : ''}>8</option>
								<option value="9" ${data.c.time_hour == '9' ? 'selected' : ''}>9</option>
								<option value="10" ${data.c.time_hour == '10' ? 'selected' : ''}>10</option>
								<option value="11" ${data.c.time_hour == '11' ? 'selected' : ''}>11</option>
								<option value="12" ${data.c.time_hour == '12' ? 'selected' : ''}>12</option>
							</select>
							
							<span>:</span>
							
							<select id="event__time_minute--${data.id}" name="b[${data.block_id}][e][${data.id}][c][time_minute]" aria-label="Event Minute">
								<option value="" ${data.c.time_minute == '' ? 'selected' : ''}></option>
								<option value="00" ${data.c.time_minute == '00' ? 'selected' : ''}>00</option>
								<option value="15" ${data.c.time_minute == '15' ? 'selected' : ''}>15</option>
								<option value="30" ${data.c.time_minute == '30' ? 'selected' : ''}>30</option>
								<option value="45" ${data.c.time_minute == '45' ? 'selected' : ''}>45</option>
							</select>
							
							<select id="event__time_ampm--${data.id}" name="b[${data.block_id}][e][${data.id}][c][time_ampm]" aria-label="Event AM/PM">
								<option value="" ${data.c.time_ampm == '' ? 'selected' : ''}></option>
								<option value="am" ${data.c.time_ampm == 'am' ? 'selected' : ''}>am</option>
								<option value="pm" ${data.c.time_ampm == 'pm' ? 'selected' : ''}>pm</option>
							</select>
						</div>
					</div>
				</div>`
			);
		}
		if(fields.expenses){
			//$entry.text('Expenses');
		}
		if(fields.location_link){
			$card_content.append(`
				<div class="gc--3 bold form__row">
					<div>
						<label for="event__location--${data.id}">Location Website Link</label>
						<input id="event__location--${data.id}" type="text" name="b[${data.block_id}][e][${data.id}][c][location_link]" value="${data.c.location_link}" />
					</div>
				</div>`
			);
		}
		
		if(fields.description){
			$card_content.append(`
				<div class="gc--3 form__row">
					<div>
						
						<span class="fake_label">Description</span>
						<div id="b[${data.block_id}][e][${data.id}][c][description]" class="tbw-editor">
							${data.c.description}
						</div>
						
					</div>
				</div>
			`);
		}
		
		$card_content.append(`
			<div class="gc--3 text_right">
				<button class="btn btn--secondary btn--tiny event_manager--open">Settings</button>
			</div>
		`)
		
		$content.append($card_content);
		
	}else{
		
		
		$content = $('<div/>', {
			'class': `e editor event border--${background_color}`
		});
		
		
		/*** START Event Branding & Buttons ***/
		/***/
		/***/
		/***/
		
		$event_branding = $('<div/>', {
			'class': `event__branding`
		});
		$event_links = $('<div/>', {
			'class': `event__links`
		});
		
			$event_branding.append(`
				<div class="event__image">
					<span class="bg--${background_color} material material-symbols-outlined">
						${style.icon}
					</span>
				</div>
			`)
		
		
			for (const [m_id, m] of Object.entries(data.m)) {
				if(Number.isInteger(m_id) || (m.lat != undefined && m.lng != undefined)){
					$event_links.append(`
						<button class="btn btn--event btn--small btn--focus_map" data-m_id="${m_id}" data-marker="${m.marker}">
							<span class="material material-symbols-outlined">
								center_focus_strong
							</span>
							Focus Map
						</button>
					`);
					
					
					// https://www.google.com/maps/dir//
					// /dir opens directions
					// / (empty first / is starting location)
					// /lat,lng for ending location
					
					$event_links.append(`
						<a target="_blank" class="btn btn--event btn--small" href="https://www.google.com/maps/dir//${m.lat},${m.lng}">
							<span class="material material-symbols-outlined">
								directions
							</span>
							Directions
						</a>
					`);
				}
			}
			/*
			
			*/
				
			if(can_display(data.c.location_link)){
				$event_links.append(`
					<a target="_blank" class="btn btn--event btn--small" href="${data.c.location_link}">
						<span class="material material-symbols-outlined">
							globe
						</span>
						Website
					</a>
				`);
			}
				
		$event_branding.append($event_links);
		$content.append($event_branding);
		
		/***/
		/***/
		/***/
		/*** END Event Branding & Buttons ***/
		
		/*** START Event Header ***/
		/***/
		/***/
		/***/
		
		$event_header = $('<div/>', {
			'class': `event__header`
		});
			
			if(can_display(data.c.name)){
				$event_header.append(`
					<h3>${data.c.name}</h3>
				`);
			}
		
		$content.append($event_header);
		
		/***/
		/***/
		/***/
		/*** END Event Branding & Buttons ***/
		
		/*** START Event Body ***/
		/***/
		/***/
		/***/
		$event_body = $('<div/>', {
			'class': `event__body`
		});
		
			if(can_display(data.c.date)){
				$event_body.append(`
					<div class="event__time v-align-middle">
						<span class="material material-symbols-outlined">
							schedule
						</span>
						<span>${data.c.date} at ${data.c.time_hour}:${data.c.time_minute}${data.c.time_ampm}</span>
					</div>
				`);
			}
			
			
			if(can_display(data.c.description)){
				$event_body.append(`
					<div class="event__description">${data.c.description}</div>
				`);
			}
			
		$content.append($event_body);
			
			
		/** HIDDEN FIELDS IF EDITOR **/
		if(Trip.has_permission){
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][name]`
				, 'value': data.c.name
			}));
			
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][style]`
				, 'value': data.c.style
			}));
			
			
			for (const [m_id, m] of Object.entries(data.m)) {
				
				$content.append($('<input/>', {
					'type': `hidden`
					, 'name': `b[${data.block_id}][e][${data.id}][m][${m_id}][id]`
					, 'value': m_id
					, 'class': 'm_id'
				}));
				
				
				$content.append($('<input/>', {
					'type': `hidden`
					, 'name': `b[${data.block_id}][e][${data.id}][m][${m_id}][lat]`
					, 'value': m.lat
					, 'class': 'lat'
				}));
				
				
				$content.append($('<input/>', {
					'type': `hidden`
					, 'name': `b[${data.block_id}][e][${data.id}][m][${m_id}][lng]`
					, 'value': m.lng
					, 'class': 'lng'
				}));
				
				
				$content.append($('<input/>', {
					'type': `hidden`
					, 'name': `b[${data.block_id}][e][${data.id}][m][${m_id}][zoom]`
					, 'value': m.zoom
					, 'class': 'zoom'
				}));
				
				$content.append($('<input/>', {
					'type': `hidden`
					, 'name': `b[${data.block_id}][e][${data.id}][m][${m_id}][type]`
					, 'value': m.type
					, 'class': 'type'
				}));
			}
			
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][date]`
				, 'value': data.c.date
			}));
			
			
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][time_hour]`
				, 'value': data.c.time_hour
			}));
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][time_minute]`
				, 'value': data.c.time_minute
			}));
			
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][time_ampm]`
				, 'value': data.c.time_ampm
			}));
			
		
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][location_link]`
				, 'value': data.c.location_link
			}));
			
		
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][directions_link]`
				, 'value': data.c.directions_link
			}));
			
		
			$content.append($('<input/>', {
				'type': `hidden`
				, 'name': `b[${data.block_id}][e][${data.id}][c][description]`
				, 'value': data.c.description.trim()
			}));
			
		}
		
	}
	
	
	$content.attr('data-el_id', data.id);
	$content.attr('data-block_id', data.block_id);
	
	if(first_m_id){
		$content.attr('data-m_id', first_m_id);
		$content.attr('data-marker', first_marker);
	}
	
	if(Trip.has_permission){
		$content.append(`<input class="element_order" type="hidden" name="b[${data.block_id}][e][${data.id}][order]" value="${data.order}" />`);
		$content.append(`<input class="element_priority" type="hidden" name="b[${data.block_id}][e][${data.id}][priority]" value="${data.priority}" />`);
		$content.append(`<input type="hidden" name="b[${data.block_id}][e][${data.id}][type]" value="event" />`);
	}
	
	return $content;
}